function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTransferCheck = function SvgTransferCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 2H3a2.006 2.006 0 0 0-2 2v12a2.006 2.006 0 0 0 2 2h7v2H8v2h8v-2h-2v-2h7a2.006 2.006 0 0 0 2-2V4a2.006 2.006 0 0 0-2-2Zm0 14H3V4h18Z",
    style: {
      fill: "#00c948"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10 17-3.5-3.5 1.41-1.41L10 14.17 15.18 9l1.41 1.41Z",
    transform: "translate(.5 -3)",
    style: {
      fill: "#00c948"
    }
  }));
};
export default SvgTransferCheck;